import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// ngrx
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { effects } from 'src/app/store';
/*  combined common modules into one file */
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxPaginationModule } from 'ngx-pagination';
import { NavigationRecordComponent } from 'src/app/shared/portal-layout/header/navigation-record/navigation-record.component';
import * as fromGuards from 'src/app/store/guards';
import { SharedModule } from '../shared/shared.module';

// components & containers
import * as fromComponents from './components';
import * as fromContainers from './containers';

// guards

import * as fromContactsReducer from '../store/reducers/contacts.reducer';
import * as fromLineItemsReducer from '../store/reducers/line-items.reducer';
import * as fromServicesReducer from '../store/reducers/services.reducer';
import * as fromTicketsReducer from '../store/reducers/tickets.reducer';

const ticketRoutes: Routes = [
  {
    path: '',
    component: fromContainers.TicketsShellComponent,
    canActivate: [
      fromGuards.DynamicAuthGuard,
      fromGuards.TicketsGuard,
      NgxPermissionsGuard,
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatFormFieldModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatPaginatorModule,
    MatIconModule,
    RouterModule.forChild(ticketRoutes),
    StoreModule.forFeature('contacts', fromContactsReducer.reducer),
    StoreModule.forFeature('services', fromServicesReducer.reducer),
    StoreModule.forFeature('tickets', fromTicketsReducer.reducer),
    StoreModule.forFeature('lineItems', fromLineItemsReducer.reducer),
    EffectsModule.forFeature(effects),
    NavigationRecordComponent,
    ...fromComponents.standaloneComponents,
  ],
  declarations: [...fromComponents.components, ...fromContainers.containers],
  providers: [],
  exports: [
    ...fromComponents.standaloneComponents,
    ...fromComponents.components,
    ...fromContainers.containers,
  ],
})
export class TicketModule {}
